import React from "react";
import { string } from "yup";

interface DrawLineProps {
    color: string;
}

export function DrawLine(props: DrawLineProps) {
  const {color} = props;
  return (
    <div style={{ border: "1px solid "+ color, marginTop:"20px"}}></div>
  )
}
